import type { Column } from '@tanstack/react-table';

export const getColumnData = (column: Column<any, unknown>) => ({
  columnId: column.id,
  type: 'column',
});

export const isColumnData = (
  type: unknown,
): type is { type: 'column'; columnId: string } =>
  typeof type === 'object' && type !== null && 'type' in type;
